import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const PaginationControls = ({
  page,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50],
  itemLabel = 'items',
}) => {
  const safePageSize = Math.max(1, pageSize);
  const totalPages = Math.max(1, Math.ceil(totalItems / safePageSize));
  const currentPage = Math.min(Math.max(1, page), totalPages);
  const start = totalItems === 0 ? 0 : (currentPage - 1) * safePageSize + 1;
  const end = Math.min(currentPage * safePageSize, totalItems);

  if (totalItems <= safePageSize && pageSizeOptions[0] === safePageSize) {
    return null;
  }

  return (
    <div className="mt-5 flex flex-col gap-3 rounded-3xl border border-[#2F78C8]/12 bg-white px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <p className="text-sm text-[#5E7791]">
          Showing {start}-{end} of {totalItems} {itemLabel}
        </p>

        <div className="flex items-center gap-2">
          <label className="text-sm text-[#5E7791]" htmlFor="page-size">
            Per page
          </label>
          <select
            id="page-size"
            value={safePageSize}
            onChange={(event) => onPageSizeChange(parseInt(event.target.value, 10))}
            className="admin-select !w-auto !py-2 !pl-3 !pr-8 !text-sm"
          >
            {pageSizeOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex items-center justify-end gap-2">
        <button
          type="button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage <= 1}
          className="admin-button-secondary !px-3 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <ChevronLeft className="h-4 w-4" />
          <span>Prev</span>
        </button>

        <span className="px-3 text-sm font-semibold text-[#173A5E]">
          {currentPage} / {totalPages}
        </span>

        <button
          type="button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
          className="admin-button-secondary !px-3 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <span>Next</span>
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;
